import React from 'react';
import './bannerMain.css';
import { useTranslation } from 'react-i18next';
import { FaArrowRight } from "react-icons/fa";

function BannerMain() {

  const { t } = useTranslation();

  return (
    
    <section className='banner-main sec_pad'>
      <div className="col-lg-12 col-md-12 col-sm-12">
            <p className='text-center p_color'>{t("banner_main.slogan")}
              <a href='/#Formulario' className="w_color">{t("landing_form.title")}  
              <FaArrowRight />            
              </a>
            </p>
            <h1 className="py-4 line-break l_height09 w_color f_700 z-index99 text-center">
              {t("banner_main.title")}
            </h1>
            <h3 className='mb-4 f--size-20 my-4 text-center w_color'>{t("banner_main.sub_title")}</h3>
            <div className='text-center z-index-9 position-relative'>
              <a href='#Formulario' className="mt-4 btn_booking">{t("form_booking_btn")}</a>
            </div>
      </div> 
    </section>
  )
}

export default BannerMain;